import React from "react";
import Grid from "@mui/material/Grid";
import { Badge, Avatar as Muiavatar, styled } from "@mui/material";

import Avatar from "../../../../components/Avatar";
import GetHeadShotName from "../../../../utils/getHeadShotName";
import { hasImage } from "../../../../utils";
import WorklogIcon from "../../../../styles/svg/woklog-icon.svg";
import "./worklog.scss";

const SmallAvatar = styled(Muiavatar)(({ theme }) => ({
  width: 16,
  height: 16,
  border: `2px solid ${theme.palette.background.paper}`,
}));

const WorklogAvatar = ({ data, showIcon }) => {
  const headShotName = GetHeadShotName(data?.username);
  return (
    <Grid>
      {showIcon ? (
        <Badge
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
          badgeContent={<SmallAvatar alt="Remy Sharp" src={WorklogIcon} />}>
          <Avatar
            title={data?.username}
            className={"header-avatar worklog-box-img"}
            user_image={data?.user_image}
            style={
              !hasImage(data?.user_image) && {
                bgcolor: data?.user_profile_color?.background,
                color: data?.user_profile_color?.text,
              }
            }>
            {headShotName}
          </Avatar>
        </Badge>
      ) : (
        <Avatar
          title={data?.username}
          className={"header-avatar worklog-box-img"}
          user_image={data?.user_image}
          style={
            !hasImage(data?.user_image) && {
              bgcolor: data?.user_profile_color?.background,
              color: data?.user_profile_color?.text,
            }
          }>
          {headShotName}
        </Avatar>
      )}
    </Grid>
  );
};

export default WorklogAvatar;
